import * as React from "react";
import { useSelector } from "react-redux";

import { LockBlack } from "@livechat/design-system-icons";
import { Icon, SpacingToken, Text } from "@livechat/design-system-react-components";

import { EmptyState } from "components/empty-state/EmptyState";
import Flex from "components/layout/Flex";
import Role from "constants/role";
import { IAgent, selectAdmins } from "store/entities/agents";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  permission: Role.Normal | Role.Viewer;
}

const AgentContent: React.FC<{ admins: IAgent[] }> = ({ admins }) => (
  <>
    You&apos;re not allowed to manage the subscription.
    <br />
    Contact {plural(admins.length, "the Admin", "one of the Admins")} to do so:
  </>
);

const ViewerContent: React.FC<{ admins: IAgent[] }> = ({ admins }) => (
  <>
    If you need the full access, contact {plural(admins.length, "the Admin", "one of the Admins")} to upgrade your
    account.
  </>
);

export const SubscriptionNoAccess: React.FC<IProps> = ({ permission }) => {
  const admins = useSelector(selectAdmins);
  const isAgent = permission === Role.Normal;
  const isViewer = permission === Role.Viewer;

  const title = isAgent ? "You cannot manage the subscription" : "You have a limited access to the app";

  return (
    <Flex alignItems="center" justifyContent="center" height="100%">
      <EmptyState title={title} icon={<Icon source={LockBlack} size="xxxlarge" />}>
        {isAgent && <AgentContent admins={admins} />}
        {isViewer && <ViewerContent admins={admins} />}
        <Flex column marginTop={withVar(SpacingToken.Spacing3)}>
          {admins.map(admin => (
            <Text key={admin.id}>
              <strong>{admin.name}</strong> ({admin.email})
            </Text>
          ))}
        </Flex>
      </EmptyState>
    </Flex>
  );
};
